export function setupIntercomForUsers (data) {
  const settings = {
    ...getIntercomSettings(data),
    ...getIntercomUserData(data)
  }

  bootIntercom(settings)
}

export function setupIntercomForGuests (data) {
  bootIntercom(getIntercomSettings(data))
}

export function updateIntercom () {
  if (!window.Intercom) {
    return
  }

  window.Intercom('update')
}

export function getIntercomSettings (data) {
  const { appId } = data

  return {
    app_id: appId,
    custom_launcher_selector: '.menuhelp_intercom, .contactbtn',
    hide_default_launcher: true,
    alignment: 'left',
    horizontal_padding: 80
  }
}

export function getIntercomUserData ({ user, userTeam, team }) {
  const { email, displayName } = userTeam
  const createdAtInUnixTime = Math.round(new Date(user.createdOn).getTime() / 1000)

  return {
    // User data
    name: displayName,
    email: email,
    user_id: user.id,
    created_at: createdAtInUnixTime,
    'custom_data.Language': getLanguage(userTeam.language),
    'custom_data.account_owner': userTeam.roles.includes('Account owner'),
    'custom_data.full_user': userTeam.roleType === 'Full user',
    'custom_data.subdomain': team.name,

    // Team data
    company: {
      company_id: team.id,
      name: team.name,
      'custom_data.admin_country': team.profile.country,
      size: getAverageTeamSize(team),
      plan: getTeamPlanInfo(team),
      custom_attributes: {
        phone: team.profile ? team.profile.phone : null
      }
    },

    // User hash for identity verification
    user_hash: user.intercomHash
  }
}

export function bootIntercom (settings) {
  window.intercomSettings = settings

  var w = window
  var ic = w.Intercom
  if (typeof ic === 'function') {
    ic('reattach_activator')
    ic('update', w.intercomSettings)
  } else {
    var d = document
    var i = function () {
      i.c(arguments)
    }
    i.q = []
    i.c = function (args) {
      i.q.push(args)
    }
    w.Intercom = i
    var l = function () {
      var s = d.createElement('script')
      s.type = 'text/javascript'
      s.async = true
      s.src = 'https://widget.intercom.io/widget/' + settings.app_id
      var x = d.getElementsByTagName('script')[0]
      x.parentNode.insertBefore(s, x)
    }
    if (document.readyState === 'complete') {
      l()
    } else if (w.attachEvent) {
      w.attachEvent('onload', l)
    } else { w.addEventListener('load', l, false) }
  }
}

export function getAverageTeamSize (team) {
  if (Number(team.companySize) === 1) {
    return 1
  }

  if (team.companySize === '2-5' || (Number(team.companySize) >= 2 && Number(team.companySize) <= 5)) {
    return 5
  }

  if (team.companySize === '5-10' || (Number(team.companySize) > 5 && Number(team.companySize) <= 10)) {
    return 10
  }

  if (team.companySize === '10-20' || (Number(team.companySize) > 10 && Number(team.companySize) <= 20)) {
    return 20
  }

  if (team.companySize === '20-more' || Number(team.companySize) > 20) {
    return 40
  }

  return null
}

export function getTeamPlanInfo (team) {
  if (!team.subscription) {
    return null
  } else if (team.subscription.status === 'trail') {
    return team.subscription.isExpired ? 'FINALISE REGISTRATION' : 'TRIAL'
  } else if (team.isPlannerAllowed) {
    return 'SUBSCRIPTION + PLANNER'
  } else {
    return 'SUBSCRIPTION'
  }
}

export function getLanguage (language) {
  const LanguagesMap = {
    EN: 'English',
    DE: 'Deutsch',
    NL: 'Nederlands'
  }

  return LanguagesMap[language] || LanguagesMap.NL
}
